/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const AssetKind = {
  Openapiv3: "openapiv3",
  Image: "image",
  Functions: "functions",
  ChatAttachment: "chat_attachment",
  Unknown: "unknown",
} as const;
export type AssetKind = ClosedEnum<typeof AssetKind>;

export type Asset = {
  /**
   * The content length of the asset
   */
  contentLength: number;
  /**
   * The content type of the asset
   */
  contentType: string;
  /**
   * The creation date of the asset.
   */
  createdAt: Date;
  /**
   * The ID of the asset
   */
  id: string;
  kind: AssetKind;
  /**
   * The SHA256 hash of the asset
   */
  sha256: string;
  /**
   * The last update date of the asset.
   */
  updatedAt: Date;
};

/** @internal */
export const AssetKind$inboundSchema: z.ZodMiniEnum<typeof AssetKind> = z.enum(
  AssetKind,
);

/** @internal */
export const Asset$inboundSchema: z.ZodMiniType<Asset, unknown> = z.pipe(
  z.object({
    content_length: z.int(),
    content_type: z.string(),
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    id: z.string(),
    kind: AssetKind$inboundSchema,
    sha256: z.string(),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "content_length": "contentLength",
      "content_type": "contentType",
      "created_at": "createdAt",
      "updated_at": "updatedAt",
    });
  }),
);

export function assetFromJSON(
  jsonString: string,
): SafeParseResult<Asset, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Asset$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Asset' from JSON`,
  );
}
